// src/components/Footer.jsx
import React from "react";

export default function Footer() {
  return (
    <footer className="bg-gray-100 py-6 mt-10 text-center text-gray-600">
      © 2026 Glow Picks. All rights reserved.
    </footer>
  );
}
